import React from "react";

function withProps(Wrapped, extraProps = {}) {
  return class WithProps extends React.PureComponent {
    render() {
      return <Wrapped {...this.props} {...extraProps} />;
    }
  };
}

export { withProps };
